import * as React from 'react'

import { styled } from 'next-yak'
import * as Redux from 'react-redux'

import { t } from '@owl-nest/localize'
import * as models from '@owl-nest/models'
import * as plume from '@ulule/owl-kit-components/next'

import { RootState } from '../../../reducers'
import * as projectModel from '../../models/project'
import { SocialSquare } from '../detail/components/SocialSquare'

export function SocialNetworks(): React.ReactElement {
  const project = Redux.useSelector<RootState, projectModel.Project>((state) => state.application.project.data)

  return (
    <Wrapper>
      <plume.styles.heading.L asDesktop="XL">{t('Follow the project on social media')}</plume.styles.heading.L>
      <Content>
        {project.links?.map((link) => (
          <Item key={link.id}>
            <SocialSquare platform={link.service_type} url={link.url}>
              {models.i18n.get(link.title)}
            </SocialSquare>
          </Item>
        ))}
      </Content>
    </Wrapper>
  )
}

const Content = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  gap: 8px;
  margin-top: 30px;
  position: relative;

  @media screen and ${plume.BREAKPOINTS.TABLET} {
    gap: 16px;
    display: grid;
    grid-template-columns: auto auto;
  }
`

const Item = styled.div`
  background: ${plume.COLORS.PRIMARY_GREY_000};
  border-radius: 4px;
  box-shadow: ${plume.EFFECTS.SHADOW_5};
  padding: 16px;

  @media screen and ${plume.BREAKPOINTS.TABLET} {
    min-width: 220px;
  }
`

const Wrapper = styled.div`
  max-width: 753px;
  margin: 40px 20px 0px 20px;

  @media screen and ${plume.BREAKPOINTS.TABLET} {
    margin: 80px auto 0 auto;
    width: 650px;
  }

  @media screen and ${plume.BREAKPOINTS.LAPTOP} {
    min-width: 753px;
  }
`
